import { api } from '@/lib/utils/axios'

export const getCompanyInfo = async () => {
  const res = await api.get('/front/v1/auth/companies/info')
  return res.data
}

export const getCompanyPolicyInfo = async () => {
  const res = await api.get('/front/v1/auth/companies/policy')
  return res.data
}

export const getCompanyPolicyInfoNoAuth = async (company_code: string) => {
  const res = await api.get('/front/v1/auth/companies/public-policy', {
    params: {
      company_code,
    },
  })
  return res.data
}
